<script>
import baseInput from './baseInput'
export default {

    name: 'simple-input',

    mixins: [ baseInput ],

    props: {
        value: null,
        id: String,
        disabled: Boolean,
        readonly: Boolean,
        type : String,
        label: String,
        labelClasses:String,
        labelInline: Boolean,
        placeholder: String,
        icon: String,
        rows: String,
        preText: String,
        min: null,
        max: null,
        noRadius: Boolean,
        isMoney: Boolean,
        upperCase: Boolean,
    },

    data:() => ({
        hasFocus: false,
    }),
    methods: {
        enter()
        {
            this.$emit('enter')
        },
        focus()
        {
            this.hasFocus = true
        },
        blur()
        {
            this.hasFocus = false
        },
    },

}
</script>

<template lang="html">
    <div class="engage-simple-input" :class="{'no-radius': noRadius }">
        <div class="form-group mb-0" :class="{ 'inlineLabel' : labelInline }">
            <label v-if="label" :for="id" :class="labelClasses"> {{ label }} </label>
            <div class="input-group">
                <div v-if="icon" @click="$emit('clickOnIcon')" class="input-group-addon text-center simpleInput" :class="{ 'focus' : hasFocus, 'disabled' : disabled }">
                    <i v-if="icon" :class="'fa fa-' + icon"></i>
                </div>
                <div  v-if="preText" class="pretext d-inline-block py-2 px-2 text-sm esh-light-bgc text-greyish9"
                :class="{ 'focus' : hasFocus, 'disabled' : disabled, 'money': isMoney }">
                    {{ preText }}
                </div>
                <input
                v-if="type=='text'"
                type="text"
                v-model="internalValue"
                :disabled="disabled"
                :readonly="readonly"
                :placeholder="placeholder"
                @keypress.enter="enter"
                :id="id"
                class="simple"
                :class="{ 'text-transform-uppercase': upperCase, 'iconed' : icon || preText, 'pl-3 border-radius-2' : !icon && !preText, 'pl-2' : preText }"
                @focus="focus"
                @blur="blur"
                :required="required"
                >
                <input
                v-if="type=='email'"
                type="email"
                v-model="internalValue"
                :disabled="disabled"
                :readonly="readonly"
                :placeholder="placeholder"
                @keypress.enter="enter"
                :id="id"
                class="simple"
                :class="{ 'iconed' : icon, 'pl-3 border-radius-2' : !icon }"
                @focus="focus"
                @blur="blur"
                :required="required"
                >
                <input
                v-if="type=='password'"
                type="password"
                v-model="internalValue"
                :disabled="disabled"
                :readonly="readonly"
                :placeholder="placeholder"
                @keypress.enter="enter"
                :id="id"
                class="simple"
                :class="{ 'iconed' : icon, 'pl-3 border-radius-2' : !icon }"
                @focus="focus"
                @blur="blur"
                :required="required"
                >
                <input
                v-if="type=='number'"
                type="number"
                v-model="internalValue"
                :disabled="disabled"
                :readonly="readonly"
                :placeholder="placeholder"
                @keypress.enter="enter"
                :id="id"
                :min="min"
                :max="max"
                class="simple"
                :class="{ 'iconed' : icon, 'pl-3 border-radius-2' : !icon, 'money': isMoney && preText, 'text-right': isMoney }"
                @focus="focus"
                @blur="blur"
                :required="required"
                >
                <textarea
                v-if="type=='textarea'"
                :rows="rows"
                v-model="internalValue"
                :disabled="disabled"
                :readonly="readonly"
                :placeholder="placeholder"
                @keypress.enter="enter"
                :id="id"
                class="simple"
                :class="{ 'iconed' : icon, 'pl-3 border-radius-2' : !icon }"
                @focus="focus"
                @blur="blur"
                :required="required"
                >
                </textarea>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/forms/elements/simpleInput.vue